<template>
  <div class="brownian-motion-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex><strong>公式：</strong>详见下方原理说明</div>
    </div>

    <div class="canvas-box">
      <svg width="100%" height="300" viewBox="0 0 400 300">
        <!-- 轨迹线 -->
        <polyline :points="pathPoints" fill="none" stroke="rgba(0, 210, 255, 0.4)" stroke-width="1.5" />
        
        <!-- 被观察的颗粒 (花粉颗粒) -->
        <circle :cx="pX" :cy="pY" r="8" fill="#ffcc33" stroke="#fff" stroke-width="1" />
        
        <!-- 无数极小的液体分子 (装饰性，体现碰撞) -->
        <circle v-for="i in 30" :key="i" :cx="molecules[i-1].x" :cy="molecules[i-1].y" r="2" fill="#00d2ff" opacity="0.3" />
      </svg>
    </div>

    <div class="explanation">
       布朗运动反映了<strong>液体分子运动的无规则性</strong>。温度越高，颗粒运动越剧烈。
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrownianMotionViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      temp: 50,
      pX: 200,
      pY: 150,
      history: [],
      molecules: Array.from({length: 30}, () => ({ x: Math.random()*400, y: Math.random()*300 }))
    }
  },
  computed: {
    pathPoints() {
      return this.history.map(p => `${p.x},${p.y}`).join(' ');
    }
  },
  mounted() {
    this.history.push({x: 200, y: 150});
    this.timer = setInterval(this.update, 100);
  },
  beforeDestroy() { clearInterval(this.timer); },
  methods: {
    update() {
      // 随机步长受温度影响
      const step = (this.temp / 10) * 2;
      this.pX += (Math.random() - 0.5) * step;
      this.pY += (Math.random() - 0.5) * step;
      
      // 边界处理
      this.pX = Math.max(20, Math.min(380, this.pX));
      this.pY = Math.max(20, Math.min(280, this.pY));
      
      this.history.push({x: this.pX, y: this.pY});
      if (this.history.length > 50) this.history.shift();
      
      // 液体分子也动一动
      this.molecules.forEach(m => {
        m.x = (m.x + (Math.random()-0.5)*10 + 400) % 400;
        m.y = (m.y + (Math.random()-0.5)*10 + 300) % 300;
      });
    }
  }
}
</script>

<style scoped lang="scss">
.brownian-motion-viz { width: 100%; color: #fff; display: flex; flex-direction: column; gap: 15px; }
.viz-header { display: flex; justify-content: space-between; padding: 10px; background: rgba(255,255,255,0.05); }
.canvas-box { background: #0a0a0a; border-radius: 8px; overflow: hidden; }
.explanation { padding: 10px; background: rgba(255, 204, 51, 0.1); border-radius: 4px; font-size: 0.85rem; color: #ffcc33; border-left: 2px solid #ffcc33; }
</style>
